import React        from 'react';
import Grid         from '@mui/material/Grid';
import {Trans}      from 'react-i18next';
import {Typography} from '@mui/material';

const FormRequiredField = () => {
	return (
		<Grid item xs={12}>
			<Trans i18nKey='form_required_field'>
				sample<br/>
				<Typography component={'span'} color='secondary'>sample</Typography>
			</Trans>
		</Grid>
	);
};

export default FormRequiredField;